const AdminPanelPage = {
  QuestionSubTopicSelection: 0,
  AchievementSelection: 1,
  KpssCompatibilitySelection: 2,
  AnswerVideoRecord : 3,
};
export default AdminPanelPage;